<div class="row px-0 mx-0 my-3">
    <div class="blocks pt-0 px-0">

        <!-- Info user Google   -->
        <div class="row pt-4 ps-4">
            <div class="d-inline">
                <i class="fab fa-google block-icons mx-2"></i>
                <span class="card-title">Informazioni Utente Google</span>
            </div>
        </div>
        <div class="row pt-4 px-4">

            <ng-container *ngFor="let obj of userGoogleFields; index as i">
                <div class="{{obj.styleClass}}">
                    <div class="my-1 ">
                        <label class="form-label label-fw px-2"> {{obj.title}}</label>
                        <br>
                        <p class="px-2">{{userGoogle[obj.field]}}</p>
                    </div>
                </div>
            </ng-container>
            <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                <div class="my-1">
                    <label class="form-label label-fw px-2">IdToken</label>
                    <br>
                    <p class="px-2">
                        {{userGoogle.idToken}}
                    </p>
                </div>
            </div>
            <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                <div class="my-1">
                    <label class="form-label label-fw px-2">AuthToken</label>
                    <br>
                    <p class="px-2">
                        {{userGoogle.authToken}}
                    </p>
                </div>
            </div>



            <div class="col-lg-4 col-md-6 col-sm-12 col-xs-12">
                <div class="my-1">
                    <label class="form-label label-fw px-2">first_issued_at</label>
                    <br>
                    <p class="px-2">
                        {{userGoogleResponse.first_issued_at | date :'dd/MMM/yyyy HH:mm:ss'}}
                    </p>
                </div>
            </div>
            <div class="col-lg-4 col-md-6 col-sm-12 col-xs-12">
                <div class="my-1">
                    <label class="form-label label-fw px-2">expires_at</label>
                    <br>
                    <p class="px-2">
                        {{userGoogleResponse.expires_at | date :'dd/MMM/yyyy HH:mm:ss'}}
                    </p>
                </div>
            </div>
            <div class="col-lg-4 col-md-6 col-sm-12 col-xs-12">
                <div class="my-1">
                    <label class="form-label label-fw px-2">expires_in</label>
                    <br>
                    <p class="px-2">
                        {{userGoogleResponse.expires_in/60}}
                    </p>
                </div>
            </div>

            <ng-container *ngFor="let obj of userGoogleResponseFields; index as i">
                <div class="{{obj.styleClass}}">
                    <div class="my-1">
                        <label class="form-label label-fw px-2"> {{obj.title}}</label>
                        <br>
                        <p class="px-2">{{userGoogleResponse[obj.field]}}</p>
                    </div>
                </div>
            </ng-container>
        </div>
    </div>
</div>



<div class="row px-0 mx-0 my-3">
    <div class="blocks pt-0 px-0">
        <div class="row pt-4 ps-4">
            <div class="d-inline">
                <i class="fas fa-server block-icons mx-2"></i>
                <span class="card-title">Informazioni Utente Backend</span>
            </div>
        </div>
        <div class="row pt-4 px-4">

            <ng-container *ngFor="let obj of userBackendFields; index as i">
                <div class="{{obj.styleClass}}">
                    <div class="my-1 d-flex">
                        <label class="form-label label-fw px-2"> {{obj.title}}</label>
                        <span>{{userBackend[obj.field]}}</span>
                    </div>
                </div>
            </ng-container>


            <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                <div class="my-1">
                    <label class="form-label label-fw px-2">Authorities</label>
                    <br>
                    <app-draggable-list-chip *ngIf="userBackend.authorities.length > 0" [draggable]="false"
                        [itemList]="userBackend.authorities" [labelKeys]="labelKeys_authorities"
                        [cancelSelectedIsEnabled]="false"
                        (changeItemList)="onChangeItemList_authorities($event)">
                    </app-draggable-list-chip>
                    <p *ngIf="userBackend.authorities.length == 0" class="px-2">Nessuno permesso collegato</p>
                </div>
            </div>
            <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                <div class="my-1">
                    <label class="form-label label-fw px-2">StoreIds</label>
                    <br>
                    <app-draggable-list-chip *ngIf="userBackend.storeIds.length > 0" [draggable]="false"
                        [itemList]="userBackend.storeIds" [labelKeys]="labelKeys_storeIds"
                        (changeItemList)="onChangeItemList_storeIds($event)">
                    </app-draggable-list-chip>
                    <p *ngIf="userBackend.storeIds.length == 0" class="px-2">Nessuno store collegato</p>
                </div>
            </div>

        </div>
    </div>
</div>